// extracted by mini-css-extract-plugin
export default {"addProjectsCTA":"SA0IautOOSgUeoRMrvyL","message":"O_gwOmdjcZftG4TPUTwU"};